import { Badge, BadgeProps } from '@mantine/core';
import { Category } from 'types';
import { getCategoryStyles } from 'utils/categoryStyles';
import classes from './CategoryBadge.module.scss';

interface ICategoryBadge extends BadgeProps {
  category: Category;
}

const CategoryBadge: React.FC<ICategoryBadge> = ({ category, ...props }) => {
  const colours = getCategoryStyles(category);
  return (
    <Badge {...props} style={colours} className={classes.badge}>
      {category.name}
    </Badge>
  );
};

export default CategoryBadge;
